module.exports = __webpack_public_path__ + "img/unrisd-logo-mobile.48b04d09.png";